/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showModal, showSpinner } from "./../Slices/sessionSlice";
import { getProjectAssignmentView } from "./../Slices/orgAdminSlice";
import { newAlert } from "./../Slices/alertSlice";
import Axios from "./../axios";
import moment from "moment";
import momentTz from 'moment-timezone';
import { changeTimzone, getDuration } from "../helpers/stubs";

const getTaskList = (slots, timezone) => {
  console.log("GET TASK LIST Called");
  //#region Group Task by {taskname, clientName, projectName, slotType} in desending order of duration
  const groupedTasks = [
    ...slots
      .reduce((acc, slot) => {
        const key = slot.task._id;
        const item = acc.get(key) || Object.assign({}, slot, { duration: 0 });

        const slotDuration = Math.floor(
          getDuration(
            changeTimzone(slot.slotFrom, timezone),
            changeTimzone(slot.slotTo, timezone)
          )
        );
        console.log("slotDuration :- ", slotDuration);
        item.duration += slotDuration;
        return acc.set(key, item);
      }, new Map())
      .values(),
  ].sort((a, b) => b.duration - a.duration);
  //#endregion

  return groupedTasks.map((slot) => ({
    name: slot.task.name,
    duration: slot.duration,
    from: slot.slotFrom,
    to: slot.slotTo,
    project: slot.task.project.name,
    supervisingClient: slot.task.project.supervisingClient.name,
    type: slot.slotType,
    _id: slot.task._id,
  }));
};

export const getWorkSlots = createAsyncThunk(
  "candidate/getWorkSlots",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.get(
        `/api/candidate/get-work-slots/${payload.userId}?day=${payload.day
        }&fetchMore=${payload.fetchMore}&timezone=${payload.timezone}${payload.candidateId ? `&candidateId=${payload.candidateId}` : ""
        }`
      );
      return {
        workSlots: data.workSlots,
        fetchMore: payload.fetchMore,
        splittedSlots: data.splittedSlots,
        timezone: payload.timezone,
      };
    } catch (err) {
      console.error("Error in canidate/getWorkSlots :- ");
      thunkApi.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      return thunkApi.rejectWithValue(err.message);
    }
  }
);
//#endregion

//#region fetch month timeline for candidate
/**
 * payload { candidateId: String, month: moment }
 */
export const getMonthTimeline = createAsyncThunk(
  "candidate/getMonthTimeline",
  async (payload, thunkAPI) => {
    try {
      const { data } = await Axios.get(
        `/api/candidate/get-month-timeline/${payload.userId}?timezone=${payload.timezone
        }&selectedDay=${payload.selectedDay}${payload.candidateId ? `&candidateId=${payload.candidateId}` : ""
        }`
      );
      return data.results;
    } catch (err) {
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      return Promise.reject(err);
    }
  }
);
//#endregion

//#region delete screenshot for candidate
export const deleteScreenshot = createAsyncThunk(
  "candidate/deleteScreenshot",
  async (payload, thunkAPI) => {
    try {
      const { data } = await Axios.put(
        `/api/candidate/delete-screenshot`,
        payload
      );

      if (Boolean(data.warning)) {
        thunkAPI.dispatch(
          newAlert({
            type: "warning",
            message: <b>{`stop the App to perform this operation`}</b>,
          })
        );
        return Promise.reject(data.warning);
      }

      thunkAPI.dispatch(
        newAlert({
          type: "success",
          message: "Successfully deleted the screenshot",
        })
      );
      return data.workSlots;
    } catch (error) {
      console.log("delete screenshot Error :- ", error);
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: "Could Not Delete Screenshot Try Again",
        })
      );
      return Promise.reject();
    }
  }
);
//#endregion

//#region  AddOfflineSlot thunk
export const addOfflineSlot = createAsyncThunk(
  "candidate/addOfflineSlot",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.put(
        "/api/candidate/add-offline-slot",
        payload
      );
      thunkApi.dispatch(showSpinner(null));
      if (!data.isTaskAdded) {
        thunkApi.dispatch(
          newAlert({ type: "danger", message: "Internal Error" })
        );
      } else {
        thunkApi.dispatch(showModal(null));
        thunkApi.dispatch(newAlert({ type: "success", message: "Slot Added" }));
        return data.workSlot;
      }
    } catch (err) {
      console.log("Addoffline thunk Error :- ", err);
      thunkApi.dispatch(showSpinner(null));
      return Promise.reject(err.message);
    }
  }
);
//#endregion

//#region editSlot
export const editSlot = createAsyncThunk(
  "candidate/editSlot",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.put("/api/candidate/edit-slot", payload);
      thunkApi.dispatch(showSpinner(null));
      if (!data.isSlotEdited) {
        throw new Error("Edit Slot Failed");
      } else {
        thunkApi.dispatch(showModal(null));
        thunkApi.dispatch(
          newAlert({ type: "success", message: "edited slot" })
        );
        return data.workSlots;
      }
    } catch (err) {
      console.log("editSlot thunk Error :- ", err);
      thunkApi.dispatch(showSpinner(null));
      thunkApi.dispatch(newAlert({ type: "danger", message: err.message }));
      return Promise.reject(err.message);
    }
  }
);
//#endregion

//#region splitSlot
export const splitSlot = createAsyncThunk(
  "candidate/splitSlot",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.put("/api/candidate/split-slot", payload);
      thunkApi.dispatch(showSpinner(null));
      if (!data.isSlotSplit) {
        thunkApi.dispatch(
          newAlert({ type: "danger", message: "Failed to split Slot" })
        );
      } else {
        thunkApi.dispatch(showModal(null));
        thunkApi.dispatch(
          newAlert({ type: "success", message: "Slot Splitted" })
        );
        return data.workSlots;
      }
    } catch (err) {
      console.log("SplitSlot thunk Error :- ", err);
      thunkApi.dispatch(
        newAlert({ type: "danger", message: "Failed to Split Slot" })
      );
      thunkApi.dispatch(showSpinner(null));
      return Promise.reject(err.message);
    }
  }
);
//#endregion

//#region editSlot
export const deleteSlot = createAsyncThunk(
  "candidate/deleteSlot",
  async (payload, thunkApi) => {
    try {
      console.log("deleteSLot", payload);
      const { data } = await Axios.put("/api/candidate/delete-slot", payload);
      thunkApi.dispatch(showSpinner(null));
      if (!data.isSlotDeleted) {
        thunkApi.dispatch(newAlert({ type: "danger", message: data.error }));
      } else {
        thunkApi.dispatch(showModal(null));
        thunkApi.dispatch(
          newAlert({ type: "success", message: "Slot Deleted" })
        );
        return data;
      }
    } catch (err) {
      console.log("deleteSlot thunk Error :- ", err);
      thunkApi.dispatch(showSpinner(null));
      thunkApi.dispatch(
        newAlert({ type: "danger", message: "Internal Error" })
      );
      return Promise.reject(err.message);
    }
  }
);
//#endregion

//#region Dashboard by time
export const getDashboardByTimePeriod = createAsyncThunk(
  "candidate/getDashboardByTimePeriod",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.get(
        `/api/candidate/get-dashboard-by-timeperiod/${payload.userId}?fromDate=${payload.fromDate}&toDate=${payload.toDate}&timezone=${payload.timezone}`
      );
      return data.dashboardData;
    } catch (err) {
      console.log("deleteSlot thunk Error :- ", err);
      thunkApi.dispatch(showSpinner(null));
      return Promise.reject(err.message);
    }
  }
);
//#endregion

//#region Get Weekly Duration
export const getWeeklyDuration = createAsyncThunk(
  "candidate/getWeeklyDuration",
  async (payload, thunkApi) => {
    try {
      const { userId, day, timezone } = payload;
      const { data } = await Axios.get(
        `/api/candidate/get-weekly-duration/${userId}?day=${day}&timezone=${timezone}${payload.candidateId ? `&candidateId=${payload.candidateId}` : ""
        }`
      );
      console.log(data);
      return data;
    } catch (err) {
      console.log("getWeeklyDuration Thunk Error :- ", err);
      return Promise.reject(err.message);
    }
  }
);
//#endregion

// #region get Acivity for day
export const getActivityForDay = createAsyncThunk(
  "candidate/getActivityForDay",
  async (payload, thunkApi) => {
    try {
      const { candidateId, day } = payload;
      const { data } = await Axios.get(
        `/api/candidate/get-activity/${candidateId}?day=${day}`
      );
      return data.activity;
    } catch (err) {
      console.error(`Error - getActivity for Day `, err);
      return Promise.reject(err.message);
    }
  }
);
// #endregion

// #region GET Tracker State
export const getTrackerState = createAsyncThunk(
  "candidate/getTrackerState",
  async (payload, thunkAPI) => {
    try {
      const { data } = await Axios.get(`/api/trackerDesktop/get-tracker-state`);
      thunkAPI.dispatch(showSpinner(null));
      return data.state;
    } catch (err) {
      console.error("Error in get Tracker state :- ", err.message);
      return Promise.reject(err);
    }
  }
);
// #endregion

// #region Save Task
export const saveTask = createAsyncThunk(
  "candidate/saveTask",
  async (payload, thunkAPI) => {
    try {
      const { data } = await Axios.put(`/api/generic/save-task`, payload);

      if (data.success) {
        if (window.location.href.includes("project-assignment")) {
          thunkAPI.dispatch(getProjectAssignmentView());
        }
        thunkAPI.dispatch(
          newAlert({ type: "success", message: "Created New Task" })
        );
      } else {
        thunkAPI.dispatch(newAlert({ type: "warning", message: data.warning }));
      }

      return true;
    } catch (err) {
      console.error("Error in Create New Task :- ", err.message);
      thunkAPI.dispatch(
        newAlert({ type: "danger", message: "Failed to Create New Task" })
      );
      return Promise.reject(err);
    } finally {
      thunkAPI.dispatch(showModal(null));
      thunkAPI.dispatch(showSpinner(null));
    }
  }
);
// #endregion

//#region SLICE
export const candidate = createSlice({
  name: "candidate",
  initialState: {
    isLoading: true,
    workSlots: [],
    screenshotImages: [],
    monthTimeline: [],
    taskList: [],
    dashboardData: [],
    weeklyDuration: 0,
    selectedDay: moment().toISOString(),
    monthChangedTo: null,
    month: moment().toISOString(),
    tracker: null,
    isFetchingMore: false,
    splittedSlots: [],
    isMonthTimeLineFetched: false,
  },

  reducers: {
    deleteScreenshotImage: (state, action) => {
      state.slots = state.slots.map((slot) => {
        slot.screenshots = slot.screenshots.filter(
          (screenshot) => screenshot.url !== action.payload.url
        );
        return slot;
      });
      // eslint-disable-next-line max-len
      state.screenshotsImages = state.screenshotsImages.filter(
        (value, idx) => idx !== action.payload.screenShotIndex
      );
    },
    addScreenshotImages: (state, action) => {
      state.screenshotImages = action.payload.screenshotImages;
    },
    changeSelectedDay: (state, action) => {
      console.log(action.payload, "change")
      state.selectedDay = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload.month;
      state.monthChangedTo = action.payload.monthChangedTo;
    },
    updateSelectedDayBasedOnTimezone: (state, action) => {
      const { timezone } = action.payload; // Get the timezone from the action
      state.selectedDay = momentTz.tz(timezone).startOf("day").toISOString();
      console.log("updateSelectedDayBasedOnTimezone", state.selectedDay)
    },
  },
  extraReducers: {
    //#region getWorkSlots reducer
    [getWorkSlots.fulfilled]: (state, { payload }) => {
      //#region If Fetch more then remove the last old work and replace with the new workslot
      if (payload.fetchMore) {
        const tempWorkslots = [...payload.workSlots, ...state.workSlots.slice(1)]
        for (let i = 0; i < tempWorkslots.length; i++) {
          tempWorkslots[i].screenshots.reverse();
        }
        state.workSlots = tempWorkslots;
      }
      //#endregion
      else {
        const tempWorkslots = payload.workSlots;
        for (let i = 0; i < tempWorkslots.length; i++) {
          tempWorkslots[i].screenshots.reverse();
        }
        state.workSlots = tempWorkslots;
        state.splittedSlots = payload.splittedSlots;
      }
      state.taskList = getTaskList(state.workSlots, payload.timezone);
      state.isFetchingMore = false;
      state.isLoading = false;
    },
    [getWorkSlots.pending]: (state, { payload }) => {
      state.isFetchingMore = true;
      state.isLoading = true;
    },
    [getWorkSlots.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.isFetchingMore = false;
    },
    //#endregion

    //#region getMonthTimeline reducer
    [getMonthTimeline.pending]: (state) => {
      state.isMonthTimeLineFetched = false;
    },
    [getMonthTimeline.fulfilled]: (state, { payload }) => {
      state.isMonthTimeLineFetched = true;
      if (payload.length > 27) {
        state.monthTimeline = payload;
      }
      if (state.monthChangedTo === "prev" || state.monthChangedTo === "next") {
        state.monthChangedTo = null;
        // Always select the first day of the new month for consistency
        state.selectedDay = momentTz(state.month).startOf("month").toISOString();
      }
    },
    [getMonthTimeline.rejected]: (state) => {
      state.isMonthTimeLineFetched = true;
    },

    //#region Add Offlie Time
    [addOfflineSlot.pending]: (state) => { },
    [addOfflineSlot.fulfilled]: (state, { payload }) => {
      state.workSlots = payload;
      state.taskList = getTaskList(payload);
    },
    [addOfflineSlot.rejected]: (state, action) => {
      console.log("Add Offline Slot rejected :- ", action);
    },
    //#endregion

    //#region DeleteScreenshot
    [deleteScreenshot.fulfilled]: (state, { payload }) => {
      state.workSlots = payload;
      state.taskList = getTaskList(payload);
    },
    [deleteScreenshot.pending]: () => { },
    [deleteScreenshot.rejected]: (state, payload) => {
      console.log("deleteScreenshot.rejected :- ", payload);
    },
    //#endregion

    //#region editSlot
    [editSlot.pending]: (state) => { },
    [editSlot.fulfilled]: (state, { payload }) => {
      state.workSlots = payload;
      state.taskList = payload.map((slot) => ({
        name: slot.task.name,
        duration: slot.duration,
        from: slot.slotFrom,
        to: slot.slotTo,
        project: slot.task.project.name,
        supervisingClient: slot.task.project.supervisingClient.name,
        type: slot.slotType,
      }));
    },
    [editSlot.rejected]: (state) => { },
    //#endregion

    //#region splitSlot
    [splitSlot.pending]: (state) => { },
    [splitSlot.fulfilled]: (state, { payload }) => {
      state.workSlots = payload;
      state.taskList = getTaskList(payload);
    },
    [splitSlot.rejected]: (state) => { },
    //#endregion

    //#region DeleteSlot
    [deleteSlot.pending]: (state) => { },
    [deleteSlot.fulfilled]: (state, { payload }) => {
      const { slotId } = payload;
      state.workSlots = state.workSlots.filter(
        (slot) => slot._id.toString() !== slotId.toString()
      );
    },
    [deleteSlot.rejected]: (state) => { },
    //#endregion

    //#region GetDashboardByTimePeriod
    [getDashboardByTimePeriod.pending]: () => { },
    [getDashboardByTimePeriod.fulfilled]: (state, { payload }) => {
      state.dashboardData = payload;
    },
    [getDashboardByTimePeriod.rejected]: (state) => { },
    //#endregion

    //#region Get Weekly Duration
    [getWeeklyDuration.pending]: (state) => {
      state.isLoading = true;
    },
    [getWeeklyDuration.fulfilled]: (state, { payload }) => {
      const { weeklyDuration, results: weeks } = payload;
      state.weeklyDuration = weeklyDuration;
      const today = weeks.find((week) => week.date === moment().get("date"));
      //#region update Today Duration in monthTime

      if (today !== undefined) {
        const todayDuration = today.duration;
        const todayIndex = today.date - 1;
        // Safety check: ensure valid index before updating monthTimeline
        if (todayIndex >= 0 && todayIndex < state.monthTimeline.length && state.monthTimeline[todayIndex]) {
          state.monthTimeline[todayIndex].duration = todayDuration;
        }
      }
      state.isLoading = false;
      //#endregion
    },
    [getWeeklyDuration.rejected]: (state) => {
      state.isLoading = false;
    },
    //#endregion

    // #region Get Activity for Day
    [getActivityForDay.pending]: () => { },
    [getActivityForDay.fulfilled]: (state, { payload }) => {
      state.activity = payload;
    },
    [getActivityForDay.rejected]: () => { },
    // #endregion

    // #region Get Tracker State
    [getTrackerState.pending]: () => { },
    [getTrackerState.fulfilled]: (state, action) => {
      state.tracker = action.payload;
    },
    [getTrackerState.rejected]: () => { },
    // #endregion

    // #region Create Task
    [saveTask.pending]: () => { },
    [saveTask.fulfilled]: () => { },
    [saveTask.rejected]: () => { },
    // #endregion
  },
});
//#endregion

// Export Actions
export const {
  deleteScreenshotImage,
  addScreenshotImages,
  changeSelectedDay,
  setMonth,
  updateSelectedDayBasedOnTimezone
} = candidate.actions;

// Export Reducer
export default candidate.reducer;
